import { render, staticRenderFns } from "./DetailsInfoFields.vue?vue&type=template&id=254b4d4c&scoped=true&"
import script from "./DetailsInfoFields.vue?vue&type=script&lang=js&"
export * from "./DetailsInfoFields.vue?vue&type=script&lang=js&"
import style0 from "./DetailsInfoFields.vue?vue&type=style&index=0&id=254b4d4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b4d4c",
  null
  
)

export default component.exports